<template>
  <div class="p-container">
    <uploader type="unit" @upload="uploadSuccess"></uploader>
    <div class="title-box">
      <div class="search-box">
        <el-input
          placeholder="部件型号、关键字"
          class="input-with-select"
          size="medium"
          v-model="keyword"
          @focus="searchFocus()"
          @keyup.enter.native="searchTo()"
        >
          <el-button
            @click="searchTo()"
            :loading="searchLoading"
            slot="append"
            icon="el-icon-search"
            title="搜索"
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="table-box">
      <el-table
        :data="unitList"
        @select="handleUnitCheckedChange"
        @select-all="handleUnitCheckedAllChange"
        v-loading="unitTableLoading"
        key="2"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="name" label="部件名称"></el-table-column>
        <el-table-column prop="stampName" label="部件类型"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="danger" @click="delUnit(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      class="select-del"
      style="margin-top: 10px"
      v-if="unitCheckedList.length > 0"
    >
      <el-button type="danger" @click="delUnit(false)">删除</el-button>
    </div>
  </div>
</template>

<script>
import Uploader from './components/uploader';
import { UNIT_TYPE } from './helper/unitType.js';
export default {
  components: {
    Uploader
  },
  data() {
    return {
      unitList: [],
      keyword: '',
      unitTableLoading: false,
      searchLoading: false,
      unitCheckedList: [],
      unitType: UNIT_TYPE
    };
  },
  watch: {},
  async mounted() {
    await this.getUnitList();
  },
  methods: {
    searchFocus() {},
    uploadSuccess(val) {
      if (val) {
        this.getUnitList();
      }
    },
    async searchTo() {
      this.searchLoading = true;
      await this.getUnitList();
    },
    async getUnitList() {
      this.unitTableLoading = true;
      try {
        const unitData = await this.$fetch(
          '/windfarm/turbineType/getUnitDataMenu',
          {
            params: {
              keyword: this.keyword
            },
            showError: true
          }
        );
        let unitList = [];
        Object.keys(unitData.data).forEach(key => {
          this.unitType.forEach(item => {
            if (item.point === key) {
              if (unitData.data[key]) {
                unitData.data[key].forEach(val => {
                  val.stampName = item.name;
                  val.type = item.type;
                  unitList.push(val);
                });
              }
            }
          });
        });
        this.unitList = unitList;
        this.unitTableLoading = false;
        this.searchLoading = false;
        return {
          data: unitList
        };
      } catch (e) {
        this.searchLoading = false;
        this.unitTableLoading = false;
        throw e;
      }
    },
    async delUnit(row) {
      let params = {};
      let id = '';
      if (!row) {
        let paramsList = {
          bladeIds: [],
          cableIds: [],
          converterIds: [],
          generatorIds: [],
          towerIds: []
        };
        this.unitCheckedList.forEach(item => {
          let ids = '';
          this.unitType.forEach(val => {
            if (item.type === val.type) {
              ids = val.id;
              paramsList[ids].push(item.pointId);
            }
          });
        });
        Object.keys(paramsList).forEach(item => {
          if (paramsList[item].length > 1) {
            paramsList[item] = paramsList[item].join(',');
          } else if (paramsList[item].length === 1) {
            paramsList[item] = paramsList[item][0].toString();
          } else {
            paramsList[item] = '';
          }
        });
        params = paramsList;
      } else {
        this.unitType.forEach(item => {
          if (item.type === row.type) {
            id = item.id;
          }
        });
        params[id] = row.pointId;
      }
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(async () => {
          await this.$fetch('/windfarm/turbineType/delUnitDataMenu', {
            params,
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          await this.getUnitList();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    handleUnitCheckedChange(val) {
      this.unitCheckedList = val;
    },
    handleUnitCheckedAllChange(val) {
      this.unitCheckedList = val;
    }
  }
};
</script>

<style lang="less" scoped>
.p-container {
  padding: 20px;
  .title-box {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .select {
      .el-dropdown-link {
        cursor: pointer;
        color: #dcdee5;
        font-size: 20px;
      }
      .el-icon-arrow-down {
        font-size: 20px;
      }
    }
    .search-box {
      .input-with-select {
        width: 400px;
      }
    }
  }
}
/deep/.el-table__empty-block {
  background-color: #fff;
}
</style>
